import { PageMeta } from "../components/PageMeta";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES, CONTACT } from "../data/content";

const Section = ({ title, children }) => (
  <Reveal>
    <div className="border-b border-amber-500/10 py-8">
      <h2 className="font-serif text-xl font-semibold text-emerald-50">{title}</h2>
      <div className="mt-3 space-y-3 text-sm font-light leading-relaxed text-slate-300/85">{children}</div>
    </div>
  </Reveal>
);

const LegalPage = ({ metaTitle, metaDesc, title, sections }) => (
  <main>
    <PageMeta title={metaTitle} description={metaDesc} />
    <PageHero image={IMAGES.dubaiSkyline} overline={sections.over} titleLines={[title]} />
    <section className="bg-[#09121F] py-20">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        {sections.items.map((s, i) => (
          <Section key={i} title={s.t}>
            <p>{s.d}</p>
          </Section>
        ))}
        <Reveal>
          <p className="pt-8 text-sm text-slate-500">
            {CONTACT.phone} ·{" "}
            <a href={CONTACT.emailHref} className="text-amber-400 hover:underline">
              {CONTACT.email}
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  </main>
);

export function PrivacyPolicy() {
  const { t } = useLanguage();
  return (
    <LegalPage
      metaTitle="Privacy Policy | Al Nama Importer"
      metaDesc="Privacy Policy of Al Nama Importer, Dubai, United Arab Emirates."
      metaTitleAr="سياسة الخصوصية | النعم للاستيراد"
      metaDescAr="سياسة الخصوصية لشركة النعم للاستيراد، دبي، الإمارات العربية المتحدة."
      title={t("legal.privacyTitle")}
      sections={{ over: t("legal.over"), items: t("legal.privacy") }}
    />
  );
}

export function TermsConditions() {
  const { t } = useLanguage();
  return (
    <LegalPage
      metaTitle="Terms & Conditions | Al Nama Importer"
      metaDesc="Terms and Conditions of using the Al Nama Importer website, Dubai, United Arab Emirates."
      metaTitleAr="الشروط والأحكام | النعم للاستيراد"
      metaDescAr="الشروط والأحكام لاستخدام موقع النعم للاستيراد، دبي، الإمارات العربية المتحدة."
      title={t("legal.termsTitle")}
      sections={{ over: t("legal.over"), items: t("legal.terms") }}
    />
  );
}
